import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { patchPalette } from '@/services/user';
import { useTheme } from '@/providers/theme-provider';
import { useAuthenticationDispatch } from '@/hooks/use-authentication';
import { errorHandler } from '@/lib/utils';
/**
 * Apply a palette locally for instant feedback, then persist to the
 * backend. On success dispatches UPDATE_USER so any tree subscribers
 * (Preferences card, sidebar submenu) stay in lockstep. Mirrors
 * useThemeMutation.
 */
export function usePaletteMutation() {
    const { setPalette } = useTheme();
    const dispatch = useAuthenticationDispatch();
    const { mutate, isPending } = useMutation({
        mutationFn: patchPalette,
        onSuccess: (data) => {
            toast.success(data.message);
            dispatch({ type: 'UPDATE_USER', user: data.user });
        },
        onError: errorHandler,
    });
    const updatePalette = (next) => {
        setPalette(next);
        mutate({ palette: next });
    };
    return { updatePalette, isPending };
}
